import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallCampaignQuickRulesBackgroundImage } from '../../../state/prizeWallCampaign/prizeWallCampaign.slice';
import PrizeWallImage from '../../common/PrizeWallImage/PrizeWallImage';

function PrizeWallQuickRulesBackground() {
  const backgroundImage = useSelector(
    selectPrizeWallCampaignQuickRulesBackgroundImage,
  );

  return (
    <PrizeWallImage
      {...backgroundImage}
      contentFit="cover"
      position="absolute"
      inset={0}
    />
  );
}

export default memo(PrizeWallQuickRulesBackground);
